<template>
    <div>
        <b-img
        @click="modalShow()" :src='`images/${imgSource}`'
        alt='Photo'
        ></b-img>
        <p>{{EmpName}}</p>
    </div>
</template>

<script>
export default {
  name: 'employee',
  props: [
    'imgSource',
    'description',
    'EmpName',
    'Website',
  ],

  methods: {
    modalShow() {
      this.$emit('openModal', this.imgSource, this.$translation.L(this.description), this.EmpName, this.Website);
    },

    resolveImgUrl(path) {
      const images = require.context('../../public/images/', false, /\.png$|\.jpg$/);
      try {
        return images(`./${path}`);
      } catch {
        return images('./blank-man.jpg');
      }
    },
  },
};
</script>

<style scoped>
    *{
       user-select: none;
       color: black;
    }
    div {
        display: inline-block;
        margin: 10px;
    }

    img {
        width: 15vw;
        height: 22.5vw;
        margin: 20px;
        cursor: pointer;
        transition: all 0.1s ease-in-out;
    }

    img:hover {
        transform: scale(0.95);
        -webkit-transform: scale(0.95);
        -ms-transform: scale(0.95);
    }

    @media only screen and (max-width: 1000px) {
        img {
            width: 30vw;
            height: 45vw;
        }
    }
</style>
